export enum PrimasJsonStringFilterOperator {
  Contains = "Contains",
  DoesNotContains = "Does Not Contains",
}